import { combineEpics, ofType } from "redux-observable"
import { from, of, concat, EMPTY } from "rxjs"
import { flatMap, catchError } from "rxjs/operators"
import { Epic } from "../../epics"

import * as actions from "./actions"
import { addErrorNotification } from "../notifications/actions"
import { RequestCancelledError } from "../../errors"
import { IAddin } from "./index"

export const defaultRequestAddinsErrorMessage =
    "Something went wrong when fetching addins."

export const requestAddinsEpic: Epic = (
    action$,
    _state$,
    { addins: { deploymentAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_ADDINS),
        flatMap(() =>
            from(deploymentAPI.getAddins()).pipe(
                flatMap((addins: IAddin[]) =>
                    of(actions.receiveAddins(addins)),
                ),
                catchError((error) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    return concat(
                        of(actions.receiveAddins([])),
                        of(
                            addErrorNotification(
                                defaultRequestAddinsErrorMessage,
                            ),
                        ),
                    )
                }),
            ),
        ),
    )

export default combineEpics(requestAddinsEpic)
